module.exports = __webpack_public_path__ + "img/UI_common_framelabelPF_02_683477de5.png";